import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import Button from '@stories/Components/Buttons/Button/Button';
import styled from 'styled-components';
const Container = styled.nav `
  display: flex;
  align-items: center;
  column-gap: ${fluid(12, 16)};
`;
const CarouselButton = styled(Button) `
  --buttonHeight: 44px;

  @media ${from(Device.TabletLarge)} {
    --buttonHeight: 54px;

    > div {
      --iconHeight: 21px;
    }
  }
`;
const ControlsStyles = {
    Container,
    CarouselButton,
};
export default ControlsStyles;
